// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format18 } from '../../constants';

/** Venezuela */
const VE: PhoneNumberData = [58, 'VE', 10, format18];

export default VE;
